import React, { memo } from 'react'

import * as styles from './quickFilterButtons.module.scss'
import QuickFilterButton from './quickFilterButton/quickFilterButton'

const QuickFilterButtons = ({
   quickFilterOptions,
   activeId,
   onButtonClick,
   isDisabled,
   wideButtons,
}: QuickFilterButtonsProps) => (
   <ul className={styles.list}>
      {quickFilterOptions.map((quickFilter) => (
         <li key={quickFilter.id}>
            <QuickFilterButton
               {...quickFilter}
               isActive={quickFilter.id === activeId}
               onButtonClick={onButtonClick}
               isDisabled={isDisabled}
               isWide={wideButtons}
            />
         </li>
      ))}
   </ul>
)

export default memo(QuickFilterButtons)
